<template>
  <div
    v-if="material && material.authorProfiles"
    class="material__author__wrapper"
  >
    <div
      v-if="!material.authorProfiles.length"
      class="material__author"
    >
      <img
        src="../../../assets/images/material-avatar.svg"
        alt="avatar"
      >
      <p>Автор редакции</p>
      <h4>{{ material.authorName || 'Редакция «за школой»' }}</h4>
    </div>

    <nuxt-link
      v-for="author in material.authorProfiles"
      :key="author.id"
      class="material__author"
      :to="`/authors/${author.id}`"
    >
      <img
        :src="getAvatarUrl(author)"
        alt="avatar"
      >
      <p>{{ author.firstName || '' }} {{ author.lastName || '' }}</p>
      <h4>{{ author.role === 'teacher' ? 'Преподаватель школы' : author.role }}</h4>
    </nuxt-link>
  </div>
</template>

<script>
export default {
  name: 'MaterialAuthor',
  props: {
    material: { type: Object, required: true },
  },
  methods: {
    getAvatarUrl(author) {
      if (author.avatar?.url) {
        return author.avatar.url;
      }

      return '../../../assets/images/material-avatar.svg';
    },
  },
};
</script>

<style scoped lang="scss">

.material__author__wrapper {
  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 8);
}

.material__author {
  display: grid;
  grid-template-columns: calc(var(--scale) * 44) auto;
  column-gap: calc(var(--scale) * 10);

  img {
    width: calc(var(--scale) * 44);
    height: calc(var(--scale) * 44);
    border-radius: 50%;
    object-fit: cover;
    grid-row: 1 / 3;
  }

  p {
    font-weight: 400;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #02120F;

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 16);
    }
  }

  h4 {
    font-weight: 500;
    font-size: calc(var(--scale) * 14);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 12);
    }
  }
}

</style>
